import React, { useMemo } from "react";
import {
  VictoryAxis,
  VictoryChart,
  VictoryLine,
  VictoryTheme,
  VictoryVoronoiContainer,
} from "victory";
import moment from "moment";


function countBookings(bookings) {
  const timeBookings = []

  const sortBookings = bookings.sort((a, b) => {
    if (moment(a.startAt).isBefore(moment(b.startAt))) return -1;
    if (moment(a.startAt).isAfter(moment(b.startAt))) return 1;
    return 0;
  });

  (sortBookings || []).forEach((book) => {
    const start = moment(book.startAt).startOf("month");
    const coincidenceIndex = timeBookings.findIndex(({ date }) => moment(date).isSame(start, "month"))
    if (coincidenceIndex >= 0) {
      timeBookings[coincidenceIndex].num += 1
    } else {
      timeBookings.push({ date: start, num: 1 })
    }
  })

  return timeBookings;
}

const NumBookingsLine = ({ rentals }) => {


  const statsBookings = useMemo(() => {

    const bookings = (rentals || []).reduce((b, rental) => {
      return [...b, ...(rental?.bookings)]
    }, [])
    return countBookings(bookings).map((s) => ({...s, date: s.date.format("MM/YYYY")}))

  }, [rentals])


  return (
    <div className="w-100 h-100 position-relative">
      <h5 className="position-absolute text-center w-100" style={{ top: 0 }}>
        Numero de reservas por mes
      </h5>
      <VictoryChart
        width={window.innerWidth}
        containerComponent={
          <VictoryVoronoiContainer labels={({ datum }) => {
            return `${datum.date}, ${datum.num} reservas`
          }}/>
        }
        height={400}
        theme={VictoryTheme.material}
      >
        <VictoryAxis fixLabelOverlap/>
        <VictoryAxis dependentAxis/>
        <VictoryLine
          theme={VictoryTheme.material}
          barRatio={0.8}
          // labelComponent={<VictoryTooltip/>}
          data={statsBookings}
          x={"date"}
          y={"num"}
          // labels={statsBookings.map(({ date }) => date)}
        />
      </VictoryChart>
    </div>

  )

}
export default NumBookingsLine